module.exports = __webpack_public_path__ + "static/media/cover-oman.facca979.png";